import { defineComponent as _defineComponent } from 'vue'
import useRouter from '@/composables/useRouter'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'
import { URLS } from '@/router/routes/urlRoutes'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'
import LfLabelButtonComponent from '@/components/forms/buttons/label/LfLabelButtonComponent.vue'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'PageNotFoundView',
  setup(__props) {

const { t } = useI18n()
const text = {
  email: t('views.error_page.email'),
  errorText: t('views.error_page.error_text'),
  goToDashboard: t('views.error_page.go_to_dashboard'),
  needHelp: t('views.error_page.need_help'),
  oops: t('views.error_page.oops'),
  phones: t('views.error_page.phones'),
  somethingWrong: t('views.error_page.something_wrong')
}

// DATA
const icon = {
  email: Icons.EMAIL,
  phone: Icons.CALL
}

// ROUTER
const { goToRoute } = useRouter()

// METHODS
function gotodashboard() {
  goToRoute({
    name: URLS.DASHBOARD
  })
}

return { __sfc: true,t, text, icon, goToRoute, gotodashboard, HeaderComponent, LfLabelButtonComponent }
}

})